module.exports = function() {
  return new Worker(__webpack_public_path__ + "8c66af6ea00851bd9f14.worker.js");
};